import { RichText } from '@uswitch/ev-core/lib/entry/page'
import richTextFieldHasContent from '@uswitch/ev-utils/lib/rich-text/has-content'
import { isChildOfContainerContext } from '@uswitch/ev-core/react'

import { Image } from './image'

const ImageTextModule = ({
  heading = {},
  content = {},
  image = {},
  footer = {},
  layout = 'image text',
  colorBlock,
  border,
  critical,
}) => {
  const mobileTemplate = `
    "image"
    "text"
    `

  const hasHeading = richTextFieldHasContent(heading)
  const hasFooter = richTextFieldHasContent(footer)

  return (
    <isChildOfContainerContext.Provider value={true}>
      <div sx={{ variant: 'layout.container.lg', ...border }}>
        <div
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', 'repeat(2, minmax(0, 1fr))'],
            gridTemplateAreas: [mobileTemplate, `"${layout}"`],
            columnGap: [null, 'clamp(24px, 5vw, 80px)'],
            rowGap: ['lg', '0'],
            alignItems: 'center',
            justifyItems: 'center',
            mb: hasFooter || border ? 0 : ['xxxl'],
            mt: hasHeading ? ['xs'] : ['md', 'xxxl'],
            px: [null, 'sm', null],
          }}
        >
          <div
            sx={{
              position: 'relative',
              gridArea: 'image',
              width: '100%',
              px: ['md', null],
              py: ['xl', null],
            }}
          >
            <Image image={image} critical={critical} />
            <If condition={colorBlock}>
              <div
                aria-hidden
                sx={{
                  position: 'absolute',
                  zIndex: '-1',
                  height: ['calc(100% + 24px)', 'calc(100% - 56px)'],
                  width: ['calc(100% + 24px)', '100%'],
                  ...colorBlock,
                }}
              />
            </If>
          </div>
          <div
            sx={{
              gridArea: 'text',
              px: ['xxxs', '0'],
            }}
          >
            <RichText content={content} />
          </div>
        </div>
      </div>
    </isChildOfContainerContext.Provider>
  )
}

export default ImageTextModule
